module.exports = __webpack_public_path__ + "static/media/single_room_preview.92a5be55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/SingleRoom/images/single_room_preview.jpg
// module id = 427
// module chunks = 0